import { FC } from 'react';
import { useTranslation } from 'hooks/useTranslation';
import { useHistory, useParams } from 'react-router-dom';
import { BKJIcon } from '@bookjane2/bookjane-design-library';
import { AddCustomerButton } from '../CustomersSettingsPage.styled';

interface AddNewCustomerButtonProps {
  onClick?: () => void;
}

export const AddNewCustomerButton: FC<AddNewCustomerButtonProps> = ({ onClick }) => {
  const { t } = useTranslation();
  const { locationId } = useParams<{ locationId: string }>();
  const history = useHistory();

  const handleAddNewCustomer = () => {
    if (onClick) {
      onClick();
    } else {
      history.push(`/settings/locations/${locationId}/customers/new`);
    }
  };

  return (
    <AddCustomerButton
      data-cy="btn-add-new-customer"
      variant="PurpleText"
      onClick={handleAddNewCustomer}
    >
      <BKJIcon iconName="Add" /> {t('location_settings:ADD_NEW_CUSTOMER')}
    </AddCustomerButton>
  );
};
